module.exports = __webpack_public_path__ + "static/media/Alike.44936f65.ttf";